import React, {Component, Fragment} from "react";

import {withTranslation} from "react-i18next";

import {Paper, Typography, Button} from "@material-ui/core";
import MaterialTable, { MTableEditField, MTableToolbar } from "material-table";

import clonedeep from "lodash.clonedeep";

class ValTab extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            confirm: false
            };
       }

   validate = (newData) => {
        for (var i=0; i < this.props.columns.length; i++) {
            var thisCol=this.props.columns[i];

            if (thisCol["required"]!=undefined) {
                if (newData[thisCol["field"]]==undefined || newData[thisCol["field"]].length==0 ) {
                    console.log("Validate error 1");
                    return false
                    }
                }

            if (thisCol["min"]!=undefined) {
                if (newData[thisCol["field"]]==undefined || newData[thisCol["field"]] < thisCol["min"]) {
                    console.log("Validate error 2");
                    return false;
                    }
                }
            if (thisCol["max"]!=undefined) {
                if (newData[thisCol["field"]]==undefined || newData[thisCol["field"]] > thisCol["max"]) {
                    console.log("Validate error 3");
                    return false;
                    }
                }
            }
        return true;
        };

    confirmDelete = () => {
        this.setState({confirm: true});
        }

    cancelDelete = () => {
        this.setState({confirm: false});
        }

    deleteAll = (event) => {
        this.setState({confirm: false});

        new Promise((resolve, reject) => {
            setTimeout(() => {
                {
                    var wrkData = clonedeep([]);
                    this.props.onUpdate(wrkData);
                }
                resolve();
                }, 100);
            });
        }

   onRowAdd = (newData) => {
        var {data, onUpdate} = this.props;

        return new Promise((resolve, reject) => {
            setTimeout(() => {
                if (this.validate(newData)) {
                    var wrkData = clonedeep(data);
                    wrkData.push(newData);
                    onUpdate(wrkData);
                    this.setState({confirm: false}, ()=>resolve());
                    } else {
                    reject();
                    }
                }, 100);

            });
        }

   onRowUpdate = (newData, oldData) => {
        var {data, onUpdate} = this.props;

        return new Promise((resolve, reject) => {
            setTimeout(() => {
                //this.setState({confirm: false});

                if (this.validate(newData)) {
                    var wrkData = clonedeep(data);
                    var index = data.indexOf(oldData);
                    wrkData[index] = newData;
                    //this.setState({ data }, () => resolve());
                    onUpdate(wrkData);
                    this.setState({confirm: false}, () => resolve());

                    // resolve();
                } else {
                    reject();
                }
            }, 100);

           });
        }

   onRowDelete = (oldData) => {
        var {data, onUpdate} = this.props;
        return new Promise((resolve, reject) => {
                setTimeout(() => {

                    var wrkData = clonedeep(data);
                    var index = data.indexOf(oldData);
                    wrkData.splice(index, 1);
                    //this.setState({ data }, () => resolve());
                    onUpdate(wrkData);
                    this.setState({confirm: false}, ()=>resolve());

                    }, 100);
                });

        }

   render = () => {
        const {t, data, onUpdate, columns, title, singleRow} = this.props;

        var editable = {
            isEditable: rowData => true, // only name(a) rows would be editable
            isDeletable: rowData => true, // only name(a) rows would be deletable
            onRowAdd: this.onRowAdd,
            onRowUpdate: this.onRowUpdate,
            onRowDelete: this.onRowDelete
            };

        var actions = [
            {icon: "delete", tooltip:t("Delete all"), isFreeAction: true, onClick: this.confirmDelete, hidden: this.state.confirm},
            {icon: "delete", iconProps: {color: "error"}, tooltip:t("Confirm delete all"), isFreeAction: true, onClick: this.deleteAll, hidden: !this.state.confirm},
            {icon: "clear", iconProps: {color: "primary"}, tooltip: t("Cancel delete"), isFreeAction: true, onClick: this.cancelDelete, hidden: !this.state.confirm}
            ];

        if (singleRow) {
            editable.isDeletable = rowData => false;
            editable.onRowAdd = undefined;
            actions = [];
            }

        return <Paper>
                <MaterialTable
                    title={title}
                    columns={columns}
                    data={data}
                    editable={editable}
                    options={{
                        search:false,
                        paging: false
                        }}
                    actions={actions}
                    components={{
                                EditField: (props) => {
                                    if (props.columnDef.required && (props.value==undefined || props.value.length === 0)) {
                                        return (<MTableEditField {...props} error label={t("Required")} />);
                                        }

                                    if (props.columnDef.min && (props.value==undefined || props.columnDef.min > props.value)) {
                                        return (<MTableEditField {...props} error label={t("Minimum ") + props.columnDef.min} />);
                                        }

                                    if (props.columnDef.max && (props.value==undefined || props.columnDef.max < props.value)) {
                                        return (<MTableEditField {...props} error label={t("Maximum ") + props.columnDef.max} />);
                                        }
                                    return (<MTableEditField {...props} />);
                                    },
                                Toolbar: (props) => {
                                    return <div>
                                            {this.state.confirm &&
                                                <Typography variant="h6" color="secondary" style={{textAlign: "right", padding: 5}}>{t("Confirm delete all")}</Typography>
                                                }
                                        <MTableToolbar {...props} />
                                        </div>;
                                    }
                        }}
                    localization = {{
                        body: {
                            addTooltip: t("Add"),
                            editTooltip: t("Edit"),
                            deleteTooltip: t("Delete"),
                            emptyDataSourceMessage: t("No records to display"),
                            editRow: {
                                saveTooltip: t("Save"),
                                cancelTooltip: t("Cancel"),
                                deleteText: t("Are you sure you want to delete this row?")
                                }
                            },
                        header: {
                            actions: t("Actions")
                            }

                        }}
                    />
           </Paper>;
        }
    }

ValTab = withTranslation()(ValTab);

export default ValTab;
